import { Dispatch } from 'redux';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';
import {
  AmbassadorInfoController,
  AmbassadorFields,
} from '../controllers/AmbassadorInfoController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';

class AmbassadorInfoCRUDActions extends CrudActionContainer {
  checkAction: string;

  constructor() {
    super('AMBASSADORS');
    this.checkAction = this.makeActionKey('CHECK');
  }

  fetch() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));
      try {
        const response = await AmbassadorInfoController.fetch();
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  update(data: AmbassadorFields) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));
      try {
        const response = await AmbassadorInfoController.update(data);
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  publish() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));
      try {
        const response = await AmbassadorInfoController.publish();
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  check(name: string) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.checkAction));
      try {
        const response = await AmbassadorInfoController.check(name);
        dispatch(this.checked(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  checked(response: { exists: boolean }) {
    return {
      exists: response.exists,
      type: this.checkAction,
    };
  }
}

export const ambassadorInfoCRUDActions = new AmbassadorInfoCRUDActions();

export const useAmbassadorInfoCRUDActions = getActionHookBuilder(
  ambassadorInfoCRUDActions,
  ['fetch', 'update', 'check', 'publish'],
);
